/**
 * UTM パラメータ名
 */
const UTM_PARAM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;

export type UtmParamKey = (typeof UTM_PARAM_KEYS)[number];

export type StoredUtmParams = Partial<Record<UtmParamKey, string>>;

const SESSION_STORAGE_KEY = "hubspot_utm";

/**
 * 現在の URL のクエリから UTM パラメータを取得する
 */
export const getUtmParamsFromSearch = (search: string): StoredUtmParams => {
	const params = new URLSearchParams(search);
	const result: StoredUtmParams = {};
	for (const key of UTM_PARAM_KEYS) {
		const value = params.get(key);
		if (value) result[key] = value;
	}
	return result;
};

/**
 * UTM が1つ以上存在するか
 */
export const hasUtmParams = (utm: StoredUtmParams): boolean => Object.keys(utm).length > 0;

/**
 * sessionStorage に UTM を保存する（流入経路トラッキング用）
 */
export const saveUtmToSession = (utm: StoredUtmParams): void => {
	if (!hasUtmParams(utm)) return;
	try {
		window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(utm));
	} catch {
		// sessionStorage が使えない環境では何もしない
	}
};

/**
 * sessionStorage から保存済み UTM を取得する
 */
export const getStoredUtmParams = (): StoredUtmParams => {
	if (typeof window === "undefined") return {};
	try {
		const raw = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
		if (!raw) return {};
		const parsed = JSON.parse(raw) as Record<string, string>;
		const result: StoredUtmParams = {};
		for (const key of UTM_PARAM_KEYS) {
			if (typeof parsed[key] === "string") result[key] = parsed[key];
		}
		return result;
	} catch {
		return {};
	}
};
